import { render, staticRenderFns } from "./WebNavbar.vue?vue&type=template&id=0687e4ba&scoped=true&"
import script from "./WebNavbar.vue?vue&type=script&lang=js&"
export * from "./WebNavbar.vue?vue&type=script&lang=js&"
import style0 from "./WebNavbar.vue?vue&type=style&index=0&id=0687e4ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0687e4ba",
  null
  
)

export default component.exports